import { observable, makeObservable } from 'mobx';
// import axios from 'axios';
import {storeGet} from "../utils/functions";

class rootStore {
  tarif={
    inited:false,
    fetching:false,
    data:null,
  };
  tarif_values={
    emails:1,
    renders:2000,
    rows:100,
    storage:100,
    access:1,
    apps:0,
    fields:5,
    logics:0,
  };
  constructor() {
    makeObservable(this,{
      tarif:observable,
      tarif_values:observable,
    });
  }
  countFree(cur, free)
  {
    const real=cur-free;
    if(real<0) {
      return 0;
    }
    return real;
  }
  calcCost(){
    const tariff = this.tarif_values;
    const tarif_cost = this.tarif.data;

    const perForm = tarif_cost.per_form;
    const perRows = this.moneyRouns(Math.ceil(this.countFree(tariff.rows, tarif_cost.free_rows) / 100) * tarif_cost.per_100_rows);
    const perFiles = this.moneyRouns(Math.ceil(this.countFree(tariff.storage, tarif_cost.free_mb) / 100) * tarif_cost.per_100_mb);
    const perUser = this.moneyRouns(this.countFree(tariff.access, tarif_cost.free_users) * tarif_cost.per_1_user);
    const perApps = this.moneyRouns(this.countFree(tariff.apps, tarif_cost.free_apps) * tarif_cost.per_1_app);
    const perFields = this.moneyRouns(this.countFree(tariff.fields, tarif_cost.free_fields) * tarif_cost.per_1_field);
    const perLogics = this.moneyRouns(this.countFree(tariff.logics, tarif_cost.free_logics) * tarif_cost.per_1_logics);
    const perEmail = this.moneyRouns(this.countFree(tariff.emails, tarif_cost.free_emails) * tarif_cost.per_1_email);
    const perRenders = this.moneyRouns(Math.ceil(this.countFree(tariff.renders, tarif_cost.free_renders) / 10) * tarif_cost.per_10_renders);

    const summ =
        this.moneyRouns(perForm +
        perRows +
        perFiles +
        perUser +
        perApps +
        perFields +
        perLogics +
        perRenders +
        perEmail)
    ;
    const summ_month=this.moneyRouns(summ*30);

    return {
      perForm, perRows, perFiles, perUser, perApps, perFields, perLogics, perRenders, perEmail, summ, summ_month
    };
  }
  moneyRouns(val) {
    return Math.round((val + Number.EPSILON) * 100) / 100;
  }
  loadTarifs() {
    storeGet("/sysapi/v2/tarif", this.tarif, true);
    console.log("LOAD TARIFS");
  }

}

export default rootStore;
